import $ from 'jquery';

const dropdown = {
  init: (elementHtmlTag, openBalise = 'a') => {
    $(elementHtmlTag).find('li.depth-0:not(.items-nb-0)').each((index, element) => {

      const clickElement = $(element).find('> '+openBalise);
      if(clickElement.length > 0)
      {
        let dropdown = new _dropdownPrivate($(element), $(clickElement[0]));
        dropdown.listen();
      }
    });
  }
};

class _dropdownPrivate {
  constructor( dropdownElementHtmlTag, openButton )
  {
    this.dropdownElementHtmlTag = dropdownElementHtmlTag;
    this.openButton = openButton;
    this.isOpen = false;
  }

  listen()
  {
    if(this.isExists(this.dropdownElementHtmlTag))
    {
      this.openButton.on('click', (e) => {
        e.preventDefault();
        this.toggle();
      });
    }
  }

  isExists(htmlElement){
    return htmlElement
      && htmlElement.length > 0
      && typeof htmlElement != 'undefined';
  }

  toggle(){
    /*
    * Check if valid variable
    * */
    if (
      !this.isExists(this.dropdownElementHtmlTag)
    ) {
      return;
    }

    this.openAnimation();

    /*
    * Open/Close focused dropdown
    * */
    if ( !this.isOpen )
    {
      document.addEventListener('mousedown', this.outsideClickListener.bind(this));
    }
    else
    {
      document.removeEventListener('mousedown', this.outsideClickListener);
    }

    this.isOpen = !this.isOpen;
  }

  outsideClickListener(event) {
    if (this.dropdownElementHtmlTag && ! this.dropdownElementHtmlTag[0].contains(event.target)) {
      if (this.isOpen === true) {
        this.toggle();
      }
    }
  }
  openAnimation(){
    this.dropdownElementHtmlTag
      .removeClass(this.isOpen ? 'dropdown-open' : 'dropdown-close')
      .addClass(this.isOpen ? 'dropdown-close' : 'dropdown-open');

    this.dropdownElementHtmlTag.find('> button')
      .attr('aria-expanded', this.isOpen ? 'false' : 'true');

    this.dropdownElementHtmlTag.find('> ul')
      .attr('aria-hidden', this.isOpen ? 'true' : 'false');
  }
};

export default dropdown;
